<template>
  <v-app-bar
    :app="$vuetify.breakpoint.mdAndUp"
    :hide-on-scroll="$vuetify.breakpoint.mdAndUp"
    height="70"
    flat
    v-if="appbar.model"
    >
    <v-container class="px-sm-10 px-0">
      <div class="d-flex justify-space-between align-center">
        <user-is-logged-in>
          <template v-slot>
            <router-link class="text--decoration-none" tag="a" exact :to="{name: 'dashboard'}">
              <div class="d-flex align-center">
                <div class="py-3"><v-img :src="app.logo" width="54"></v-img></div>
              </div>
            </router-link>
          </template>

          <template v-slot:unpermitted>
            <router-link class="text--decoration-none" tag="a" exact :to="{name: 'home'}">
              <div class="d-flex align-center">
                <div><v-img :src="app.logo" width="54"></v-img></div>
              </div>
            </router-link>
          </template>
        </user-is-logged-in>

        <!-- <can code="submissions.index">
          <v-btn text exact large color="secondary" class="mr-4" :to="{ name: 'submissions.index' }">
            {{ __('Submissions') }}
          </v-btn>
        </can> -->

        <user-is-logged-in>
          <template v-slot:unpermitted>
            <template v-if="isLogInPage">
              <v-btn color="primary" large exact :to="{ name: 'signup' }">
                <strong>{{ __('Sign up') }}</strong>
              </v-btn>
            </template>

            <template v-else>
              <v-btn color="primary" large exact :to="{ name: 'login' }">
                <strong>{{ __('Sign in') }}</strong>
              </v-btn>
            </template>
          </template>
        </user-is-logged-in>

        <user-is-logged-in>
          <v-menu
            class="justify-end d-flex"
            min-width="200px"
            transition="slide-y-transition"
            >
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <div v-on="{ ...tooltip, ...menu }" role="button">
                    <div class="d-flex justify-space-between align-center">
                      <v-avatar size="32" class="mr-3"><img :src="user.avatar" width="40px"></v-avatar>
                        <div class="d-none d-md-block">
                          <p class="body-1 mb-0" v-text="user.displayname"></p>
                          <div v-text="user.role" class="muted--text overline"></div>
                        </div>
                    </div>
                  </div>
                </template>
                <span v-text="user.displayname"></span>
              </v-tooltip>
            </template>

            <v-list>
              <v-list-item exact :to="{ name: 'myprofile' }">
                <v-list-item-action>
                  <v-icon small class="text--muted">mdi-account-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="trans('My Profile')"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item @click="handleLogout">
                <v-list-item-action>
                  <v-icon small class="text--muted">mdi-power</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="trans('Logout')"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </user-is-logged-in>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import app from '@/config/app'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Appbar',

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters({
      appbar: 'appbar/appbar',
      sidebar: 'sidebar/sidebar',
      user: 'auth/user',
      lang: 'app/locale',
    }),

    app: function () {
      return app
    },

    isLogInPage () {
      return this.$route.name == 'login'
    }
  },

  methods: {
    ...mapActions({
      toggle: 'sidebar/toggle',
      logout: 'auth/logout',
    }),

    handleLogout () {
      this.logout()
      window.location.href = '/logout'
    },
  },
}
</script>
